import { render, staticRenderFns } from "./coinsTitleSperator.vue?vue&type=template&id=a3121714&scoped=true&"
import script from "./coinsTitleSperator.vue?vue&type=script&lang=ts&"
export * from "./coinsTitleSperator.vue?vue&type=script&lang=ts&"
import style0 from "./coinsTitleSperator.vue?vue&type=style&index=0&id=a3121714&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3121714",
  null
  
)

export default component.exports